export default "__VITE_ASSET__c20f80bb__"